"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualCoverRefundCancellationOutput = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var AnnualCoverRefundCancellationOutput = /** @class */ (function (_super) {
    __extends(AnnualCoverRefundCancellationOutput, _super);
    function AnnualCoverRefundCancellationOutput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnualCoverRefundCancellationOutput.prototype.render = function () {
        var isFullRefundProvided = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY ?
            parseFloat(this.props.interaction.factors.returnPremium) === parseFloat(this.props.interaction.paymentDetails.instalmentPlan.deposit)
            : parseFloat(this.props.interaction.factors.returnPremium) === parseFloat(this.props.interaction.factors.annualPremium);
        return (React.createElement("div", { className: "policy-cancellation-description" },
            React.createElement("h1", { className: "text-center text-blue-1" },
                "Your ",
                services_1.productHelper.isHome(this.props.interaction) ? 'home' : 'car',
                " policy will be cancelled"),
            !isFullRefundProvided && React.createElement("p", { className: "text-center font-weight-semi-bold" },
                "Your ",
                services_1.productHelper.isHome(this.props.interaction) ? 'home' : 'car',
                " policy will end on ",
                " ",
                (0, commonFunctions_1.convertDate)(this.props.interaction.headerInfo.endDate, "DD MMMM YYYY"),
                ", 23:59"),
            services_1.productHelper.isWolfMotor(this.props.interaction) && React.createElement("p", { className: "text-center font-weight-semi-bold" },
                "We will send your ",
                React.createElement("strong", null, "Proof of No Claims Discount"),
                " and an email confirmation, when the policy is cancelled"),
            !isFullRefundProvided && React.createElement("p", { className: "text-center" }, "Until then you are still covered.")));
    };
    return AnnualCoverRefundCancellationOutput;
}(plugin_journey_1.WidgetBase));
exports.AnnualCoverRefundCancellationOutput = AnnualCoverRefundCancellationOutput;
//# sourceMappingURL=AnnualCoverRefundCancellationOutput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualCoverRefundCancellationOutput.js
// module id = 3183
// module chunks = 0